import {getChordInstance} from '../chord-analytics'

export const useChordEvents = () => {
    const chord = getChordInstance()
    const trackCartViewed = (cartData) => {
        if (!chord || !cartData) return
        chord
            .trackCartViewed({
                cart: cartData
            })
            .then(() => console.log('Cart Viewed event sent successfully!'))
            .catch((e) => console.error('Cart Viewed event failed:', e))
    }

    const trackProductAdded = ({cartItems, cartId, currency}) => {
        if (!chord || !cartItems || !cartId) return
        const product = cartItems?.[0]
        const pathname = window?.location?.pathname
        const locale = pathname?.split('/')[1]
        chord
            .track('Product Added', {
                cart_id: cartId,
                total: product?.total,
                value: product?.price,
                price: product?.price,
                currency: currency,
                sku: product?.productId || product?.id,
                product_id: product?.productId || product?.id,
                name: product?.name || product?.productName,
                product: cartItems?.map((product) => {
                    const variationValues = product?.variationValues
                    let variant

                    if (
                        variationValues &&
                        Object.keys(variationValues)?.length > 0
                    ) {
                        const values = Object.values(variationValues)
                        variant =
                            values?.length >= 2
                                ? `${values?.[0]} / ${values?.[1]}`
                                : values?.[0]
                    } else {
                        variant = product?.productName || product?.name
                    }
                    const host =
                        typeof window !== 'undefined'
                            ? window?.location?.origin
                            : ''
                    return {
                        product_id: product?.productId || product?.id,
                        sku: product?.productId || product?.id,
                        name: product?.name || product?.productName,
                        price: product?.price,
                        quantity: product?.quantity,
                        image_url: product?.imageGroups?.[0]?.images[0]?.link,
                        variant: variant,
                        product_url: `${host}/${locale}/product/${
                            product?.c_productsUniqueName || product?.id
                        }`
                    }
                })
            })
            .then(() => console.log('Product Added event sent successfully!'))
            .catch((e) => console.error('Product Added event failed:', e))
    }

    const trackSignUp = ({email, name, phone}) => {
        if (!chord || !email) return
        chord
            .track('sign_up', {
                email,
                name,
                phone,
                source: 'PWA'
            })
            .then(() => console.log('Sign Up event sent successfully!'))
            .catch((e) => console.error('Sign Up event failed:', e))
    }

    const trackSignIn = ({email}) => {
        if (!chord || !email) return
        chord
            .track('sign_in', {
                email,
                source: 'PWA'
            })
            .then(() => console.log('Sign In event sent successfully!'))
            .catch((e) => console.error('Sign In event failed:', e))
    }

    const trackSignOut = ({email}) => {
        if (!chord || !email) return
        chord
            .track('sign_out', {
                email,
                source: 'PWA'
            })
            .then(() => console.log('Sign Out event sent successfully!'))
            .catch((e) => console.error('Sign Out event failed:', e))
    }
    const trackOrderCompleted = ({order, customerId}) => {
        if (!chord || !order) return
        chord
            .track('Order Completed', {
                order_id: order?.orderNo,
                order_date: order?.creationDate,
                total: order?.orderTotal,
                currency: order?.currency,
                revenue: order?.productTotal || order?.orderTotal,
                tax: order?.taxTotal,
                shipping: order?.shippingTotal,
                products: order?.productItems?.map((product, index) => {
                    const variationValues = product?.variationValues
                    let variant

                    if (
                        variationValues &&
                        Object.keys(variationValues).length > 0
                    ) {
                        const values = Object.values(variationValues)
                        variant =
                            values.length >= 2
                                ? `${values[0]} / ${values[1]}`
                                : values[0]
                    } else {
                        variant = product?.productName || product?.name
                    }
                    return {
                        product_id: product?.productId || product?.id,
                        name: product?.productName || product?.name,
                        price: product?.price,
                        quantity: product?.quantity,
                        sku: product?.productId || product?.id,
                        variant: variant,
                        position: index
                    }
                }),
                user_id: customerId
            })
            .then(() => console.log('Order Completed event sent successfully!'))
            .catch((e) => console.error('Order Completed event failed:', e))
    }
    const trackCheckoutStarted = ({checkout}) => {
        if (!chord || !checkout) return
        chord
            .track('Checkout Started', {
                cart_id: checkout?.basketId,
                currency: checkout?.currency,
                value: checkout?.orderTotal,
                products: checkout?.productItems?.map((product) => {
                    const variationValues = product?.variationValues
                    let variant

                    if (
                        variationValues &&
                        Object.keys(variationValues).length > 0
                    ) {
                        const values = Object.values(variationValues)
                        variant =
                            values?.length >= 2
                                ? `${values?.[0]} / ${values?.[1]}`
                                : values?.[0]
                    } else {
                        variant = product?.productName || product?.name
                    }
                    return {
                        product_id: product?.productId || product?.id,
                        name: product?.productName || product?.name,
                        sku: product?.productId || product?.id,
                        price: product?.price,
                        quantity: product?.quantity,
                        variant: variant
                    }
                })
            })

            .then(() =>
                console.log('Checkout Started event sent successfully!')
            )
            .catch((e) =>
                console.error('Checkout Started event event failed:', e)
            )
    }

    return {
        trackCartViewed,
        trackProductAdded,
        trackSignUp,
        trackSignIn,
        trackSignOut,
        trackOrderCompleted,
        trackCheckoutStarted
    }
}
